/**
 * Class to add api uris for the application
 */
export class ApiUriConstants {
  public static AGENT_SESSION_URI =
    '/InContactAPI/services/v23.0/agent-sessions';
  public static JOIN_AGENT_SESSION_URI =
    '/InContactAPI/services/v23.0/agent-sessions/join';
  public static GET_NEXT_EVENT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/get-next-event?timeout={timeoutSec}';
  public static GET_NEXT_EVENT_TIMEOUT = '60';
  public static HOLD_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/hold';
  public static RESUME_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/resume';
  public static MUTE_AGENT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/agent-phone/mute';
  public static UNMUTE_AGENT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/agent-phone/unmute';
  public static DIAL_PHONE_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/dial-phone';
  public static MASK_CALL_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/mask';
  public static UNMASK_CALL_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/unmask';
  public static RECORD_CALL_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/record';
  public static END_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/end';
  public static AGENT_STATE_URI =
    '/InContactAPI/services/v23.0/cache/agentstate';
  public static SKILL_ACTIVITY_URI =
    '/InContactAPI/services/v23.0/skills/activity';
  public static CONFERENCE_CALL_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/conference-calls';
  public static CONSULT_AGENT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/consult-agent';
  public static DIAL_AGENT_LEG_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/agent-phone/dial';
  public static END_AGENT_LEG_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/agent-phone/end';

  // Api for urls for address book
  public static ADDRESS_BOOK_URI =
    '/incontactapi/services/v23.0/agents/{agentId}/address-books';
  public static STANDARD_ADDRESS_BOOK_URI =
    '/incontactapi//services/v23.0/address-books/{addressBookId}/entries';
  public static GET_AGENT_SKILLS_URI =
    '/InContactAPI/services/v23.0/agents/{agentId}/skills';
  public static SET_AGENT_STATE_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/state';
  public static DIAL_AGENT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/dial-agent';
  public static DIAL_SKILL_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/dial-skill';
  public static TRANSFER_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/transfer-calls';
  public static SEND_DTMF =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/send-dtmf';
  public static SKILL_CACHE_URI = '/InContactAPI/services/v23.0/cache/skills';
  public static GET_SKILLS_URI = '/InContactAPI/services/v23.0/skills';
  public static AGENT_QUEUE_URI =
    '/incontactapi/services/v23.0/agents/{agentId}/queues';
  public static AGENT_QUEUE_DETAIL_URI =
    '/incontactapi/services/v23.0/agents/{agentId}/queues-detail';

  //Api uris to accept and reject inbound contact
  public static ACCEPT_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/accept';
  public static REJECT_CONTACT_URI =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/reject';
  public static POST_CUSTOM_FORM_DATA =
    '/InContactAPI/services/v23.0/agent-sessions/{sessionId}/interactions/{contactId}/custom-data';
}
